<script>
  import { onDestroy, onMount, tick } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import Alert from '@components/Alert.svelte';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let sectionsStore = getGroupStore('sectionsStore');
  import Track from '@utils/track';
  import ComponentEvents from '@utils/component-events';

  import StepOne from './add_rec_external/StepOne.svelte';
  import StepTwo from './add_rec_external/StepTwo.svelte';

  import GroupIdeasBuilder from '@app-components/group_ideas/GroupIdeasBuilder.svelte';

  import { createEventDispatcher } from 'svelte';
  import { getCurrentUserStore } from '@stores/current_user';

  const dispatch = createEventDispatcher();
  import jQuery from 'jquery';

  export let mobile = false;
  export let showModal = false;
  export let showSectionSelector = true;
  export let recommendationNamePlaceholder = `E.g. Joe's Pizza, Vista Stroller, amazon.com/xyz`;
  export let allowClose = true;
  export let quizQuestion = null;
  export let skipStepOne = false;
  export let beforeSaveDataModifier = async (data) => data;
  export let name;
  export let createGroupAndRec;
  export let preferAffiliate = false;
  export let preferAffiliateTopCount = 3;
  export let localized = true;
  export let searchHelper = '';

  let modalId = null;
  let group = groupStore;
  let sections = sectionsStore;
  let step = skipStepOne ? 2 : 1;
  let selectedRecObject;
  let fetchWebResult;
  let fetchCustomization;
  let fetchRecObject;
  let focusNote;
  let selectedOption;
  let scrollSpyEnabled = true;
  let headerText;
  let currentUser = getCurrentUserStore('default');

  let showIdeaStep = false;
  let ideaGenerated = false;

  $: if (modalId == null) {
    modalId = (Math.random() + 1).toString(36).substring(7) + (Math.random() + 1).toString(36).substring(7);
  }

  let unsubSectionsStore = sectionsStore.subscribe((x) => (sections = x));

  let showCancelChangesDialog = false;

  $: if (step === 1 && selectedRecObject) {
    headerText = 'Add Note and Confirm';
  } else {
    headerText = quizQuestion
      ? `Enter keywords or link to your ${quizQuestion.q} recommendation`
      : 'Enter Keywords or Link';
  }

  $: if (step === 2) {
    allowClose = false;
  }

  let close = function () {
    step = 1;
    selectedRecObject = null;
    name = '';
    showModal = false;
    modalId = null;
    showIdeaStep = false;
    ideaGenerated = false;
    dispatch('close');
  };

  let closeBtnClicked = function () {
    if (step === 2 || selectedRecObject) {
      showCancelChangesDialog = true;
    } else {
      close();
    }
  };

  let moveToIdeaStep = function () {
    name = '';
    showIdeaStep = true;
  };

  let moveToNonIdeaStep = function () {
    name = '';
    showIdeaStep = false;
  };

  let moveToStepOne = async function () {
    if (skipStepOne && !selectedRecObject) {
      close();
      return;
    }

    if (!selectedRecObject) {
      ideaGenerated = false;
    }

    step = 1;
    showIdeaStep = false;
    await tick();
    jQuery('#select-recommendation-input').focus();
  };

  let moveToStepTwo = function (fetch = true, extra = undefined) {
    step = 2;
    Track.autofillViewed({ user: currentUser, group, name });

    if (fetch) {
      if (extra && extra.type) {
        if (extra.type === 'customization') {
          fetchCustomization(extra.id);
        } else if (extra.type === 'recobject') {
          fetchRecObject(extra.id);
        }
      } else {
        fetchWebResult(name);
      }
    }
  };

  let unsubCurrentSection = ComponentEvents.on('current-section', (data) => {
    if (data && data.section && scrollSpyEnabled) {
      selectedOption = { label: data.section.name, value: data.section };
    }
  });

  let unsubShowSectionBarEvent = ComponentEvents.on('section-bar-show', function (data) {
    if (data && data.section) {
      scrollSpyEnabled = false;
      selectedOption = { label: data.section.name, value: data.section };
      setTimeout(() => (scrollSpyEnabled = true), 1000);
    }
  });

  onMount(() => {
    if (skipStepOne && step === 2 && name && name != '') {
      moveToStepTwo();
    }
  });

  onDestroy(() => {
    unsubSectionsStore();
    unsubCurrentSection();
    unsubShowSectionBarEvent();
  });
</script>

<style style="text/scss" lang="scss">
  .close-btn {
    position: absolute;
    right: 14px;
    top: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 20px;

    &:hover {
      path {
        stroke: #a893f9;
        fill: #a893f9;
      }
    }
  }

  .ideas-group-btn {
    position: absolute;
    top: 14px;
    left: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: #896bd9;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .mobile {
    .close-btn {
      float: right;
      position: absolute;
      top: 84px;
      right: 20px;

      path {
        fill: black;
      }
    }

    .ideas-group-btn {
      top: 84px;
      left: 25px;
      font-size: 12px;
    }
  }

  .modal__close {
    color: #7f7f7f;
    background: transparent;
    border: 0;
    cursor: pointer;
    z-index: 2;

    &:hover {
      font-weight: bold;
    }

    &:before {
      content: '\2715';
      font-size: 16px;
    }
  }

  * :global(.mobile-modal-overlay-class) {
    will-change: unset !important;
  }

  * :global(.mobile-container-class) {
    will-change: unset !important;
  }

  * :global(.group-ideas-builder-header) {
    margin-top: -30px;
  }
</style>

<div class="svelte-modal">
  <Alert
    mobile={mobile}
    on:yes-click={() => {
      close();
    }}
    question="Are you sure you want to delete this?"
    yesButtonText="Delete"
    objectText={null}
    bind:show={showCancelChangesDialog} />

  <Modal
    closeOnOverlayClick={false}
    mobile={mobile}
    allowClose={allowClose}
    overlayClass={mobile ? 'mobile-modal-overlay-class' : ''}
    containerClass={mobile ? 'mobile-container-class' : ''}
    on:close={close}
    on:overlay-clicked={closeBtnClicked}
    show={showModal}
    showCloseButton={false}
    fadeInDuration={200}
    style="{mobile ? 'margin-bottom: 30px !important;' : 'width: 490px;'}
  {!mobile && step == 2
      ? 'width: 952px; max-width: 952px; min-height: 380px; height: calc(100vh - 60px); overflow: hidden; padding-bottom: 0px;'
      : ''}
  border-radius: 16px;">
    <div slot="content" class:mobile={mobile}>
      {#if step === 1 && group.idea_group && group.idea_group_topics && group.idea_group_topics.length > 0 && !showIdeaStep && !selectedRecObject}
        <div class="ideas-group-btn" on:click={moveToIdeaStep}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M8 0C3.584 0 0 3.20129 0 7.20291C0.0119592 8.165 0.22668 9.11375 0.630127 9.98717C1.03357 10.8606 1.61665 11.639 2.34131 12.2716L2.13336 15.5583C2.12964 15.6358 2.14737 15.7129 2.18463 15.7809C2.22189 15.849 2.27719 15.9055 2.34448 15.9441C2.41177 15.9827 2.48843 16.002 2.56598 15.9998C2.64353 15.9977 2.71897 15.9741 2.784 15.9318L5.58398 14.0644C6.36959 14.2897 7.18273 14.4046 8 14.4058C12.416 14.4058 16 11.2045 16 7.20291C16 3.20129 12.416 0 8 0ZM7.64801 11.9408C7.41746 11.9398 7.19236 11.8705 7.0011 11.7417C6.80984 11.6129 6.66098 11.4303 6.57324 11.2171C6.4855 11.0038 6.46282 10.7693 6.50806 10.5431C6.55329 10.3169 6.66443 10.1092 6.82745 9.94614C6.99048 9.78304 7.19812 9.67187 7.42419 9.62662C7.65027 9.58136 7.88463 9.60404 8.09784 9.69182C8.31104 9.7796 8.49351 9.92854 8.62225 10.1199C8.751 10.3112 8.8203 10.5364 8.82135 10.767C8.82206 10.9214 8.79218 11.0743 8.73346 11.2171C8.67474 11.3598 8.58834 11.4895 8.47925 11.5986C8.37015 11.7077 8.24051 11.7942 8.09784 11.8529C7.95517 11.9117 7.80229 11.9415 7.64801 11.9408ZM9.38666 7.26694C8.91732 7.64042 8.672 7.85385 8.672 8.222C8.672 8.48803 8.56633 8.74316 8.3783 8.93127C8.19026 9.11939 7.93524 9.22507 7.66931 9.22507C7.40339 9.22507 7.14836 9.11939 6.96033 8.93127C6.77229 8.74316 6.66669 8.48803 6.66669 8.222C6.66669 6.93615 7.46668 6.28521 8.05334 5.81035C8.42134 5.51156 8.64001 5.31948 8.64001 5.13808C8.64001 4.95667 8.64001 4.5085 7.64801 4.5085C7.27478 4.50429 6.907 4.59812 6.58136 4.78061C6.42142 4.88214 6.23728 4.93922 6.04797 4.946C5.79337 4.946 5.54924 4.84483 5.3692 4.66472C5.18917 4.48461 5.08801 4.24032 5.08801 3.98561C5.09064 3.80749 5.14164 3.63346 5.2356 3.48213C5.32955 3.33081 5.4629 3.20791 5.62134 3.1266C6.25916 2.72453 7.00091 2.5186 7.75464 2.53436C9.50931 2.53436 10.688 3.55878 10.688 5.08473C10.6705 5.52896 10.5423 5.96176 10.315 6.3438C10.0877 6.72584 9.76859 7.045 9.38666 7.27228V7.26694Z"
              fill="#AE94F9" />
          </svg>
          <div>Ideas</div>
        </div>
      {/if}

      {#if allowClose}
        <div class="close-btn modal__close" on:click={closeBtnClicked} />
      {/if}

      <div style="display: {step == 1 ? 'block' : 'none'}">
        {#if showIdeaStep}
          <GroupIdeasBuilder
            group={group}
            mobile={mobile}
            currentUser={currentUser}
            selectOnlyCategories={true}
            selectedIdea={{ data: { categories: group.idea_group_topics } }}
            on:back={moveToNonIdeaStep}
            displayAutofill={(searchTerm) => {
              name = searchTerm;
              ideaGenerated = true;
              moveToStepTwo();
            }} />
        {:else}
          <StepOne
            bind:selectedRecObject={selectedRecObject}
            bind:name={name}
            bind:focusNote={focusNote}
            bind:selectedOption={selectedOption}
            beforeSaveDataModifier={beforeSaveDataModifier}
            showSectionSelector={showSectionSelector}
            sections={sections}
            moveToStepTwo={moveToStepTwo}
            headerText={headerText}
            group={group}
            close={close}
            mobile={mobile}
            recommendationNamePlaceholder={recommendationNamePlaceholder}
            modalId={modalId}
            quizQuestion={quizQuestion}
            createGroupAndRec={createGroupAndRec}
            ideaGenerated={ideaGenerated}
            on:added={(e) => {
              dispatch('added', e.detail);
            }} />
        {/if}
      </div>

      <div style="display: {step == 2 ? 'block' : 'none'}">
        <StepTwo
          focusNote={focusNote}
          bind:selectedRecObject={selectedRecObject}
          bind:name={name}
          bind:fetchWebResult={fetchWebResult}
          bind:fetchCustomization={fetchCustomization}
          bind:fetchRecObject={fetchRecObject}
          recommendationNamePlaceholder={recommendationNamePlaceholder}
          moveToStepOne={moveToStepOne}
          mobile={mobile}
          modalId={modalId}
          preferAffiliate={preferAffiliate}
          preferAffiliateTopCount={preferAffiliateTopCount}
          localized={localized}
          searchHelper={searchHelper} />
      </div>
    </div>
  </Modal>
</div>
